// extracted by mini-css-extract-plugin
module.exports = {"marketing-image-hover":"marketing-image-hover_X429N","list-item-img":"list-item-img_2R0z4"};